import React, { useState, createContext, useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AuthHelper } from '../../../common/helper';
import { AdminUser } from '../../redux/modules';
import { Private } from '../../firestore_model';
import { useInjection } from '../../../di_container/InjectionProvider';
export const _useAuthUser = () => {
    const { container } = useInjection();
    const [state, setState] = useState({ loading: true });
    const adminDispatch = useDispatch();
    useEffect(() => {
        let enabled = true;
        const authRepository = container.resolve('AuthRepository');
        const listener = authRepository.onAuthListener(async (user) => {
            var _a;
            if (user != null) {
                const uesrId = user.uid;
                const tokenResult = await ((_a = user) === null || _a === void 0 ? void 0 : _a.getIdTokenResult(true));
                let userType;
                if (AuthHelper.isUserType('adminUser', tokenResult)) {
                    userType = 'adminUser';
                    const privateAdmin = await Private.Admin.get(uesrId);
                    adminDispatch({ type: AdminUser.ActyonType.ADMIN_SAVE, privateAdmin: privateAdmin });
                }
                else if (AuthHelper.isUserType('clinicUser', tokenResult)) {
                    userType = 'clinicUser';
                }
                if (enabled) {
                    setState({
                        user: user,
                        userType,
                        loading: false,
                        error: undefined,
                    });
                }
            }
            else {
                adminDispatch({ type: AdminUser.ActyonType.ADMIN_SAVE, privateAdmin: undefined });
                if (enabled) {
                    setState({
                        user: undefined,
                        userType: 'none',
                        loading: false,
                        error: undefined,
                    });
                }
            }
        }, (error) => {
            if (enabled) {
                setState({
                    loading: false,
                    error: error,
                });
            }
        });
        return () => {
            enabled = false;
            listener();
        };
    }, []);
    return {
        user: state.user,
        userType: state.userType,
        loading: state.loading,
        error: state.error,
    };
};
export const AuthContext = createContext({ loading: false });
export const AuthProvider = ({ children }) => {
    const { user, userType, loading, error } = _useAuthUser();
    return (React.createElement(AuthContext.Provider, { value: {
            user,
            userType,
            loading,
            error,
        } }, children));
};
export const useAuthUser = () => useContext(AuthContext);
